export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50">小小影院</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300/60">
              高清免费在线观看不缓冲的影视平台，覆盖热门电视剧和电影大全，每日更新最新高清资源，无需注册即可流畅观影。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '影视分类', href: '#index' },
                { label: '精彩预告', href: '#media' },
                { label: '精选推荐', href: '#cards' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById(link.href.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-300/60 hover:text-accent-300 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById(link.href.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-300/60 hover:text-accent-300 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-300/40">
              更多合作伙伴信息敬请期待
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/40">
            &copy; 2026 小小影院 - 高清免费在线观看不缓冲 | 免费影视流畅观影
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-300/40 hover:text-accent-300 transition-colors whitespace-nowrap">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}